import { useMemo } from 'react';
import { Button, Tooltip } from '@bigcommerce/big-design';
import { useExportSelected } from '../hooks/useExportSelected';
import { FilterFlexItem } from './FilterFlexItem';

export function ExportFilterAction({ selectedItems, vendor }) {
	const [handleExport, isExporting] = useExportSelected(
		selectedItems,
		vendor,
	);
	/** @type {String} */
	const exportText = useMemo(() => {
		if (vendor?.length <= 0) {
			return {
				button: 'Select Vendor',
				tooltip: 'Select a vendor to export orders',
			};
		}
		if (selectedItems?.length <= 0) {
			return {
				button: 'Select Orders',
				tooltip: 'Select orders to export',
			};
		}
		return {
			button: 'Export',
			tooltip: `Export ${selectedItems.length} ${
				selectedItems.length === 1 ? 'order' : 'orders'
			} to PDF and CSV files`,
		};
	}, [vendor, selectedItems]);

	return (
		<>
			<FilterFlexItem>
				<Tooltip
					trigger={
						<Button
							variant="secondary"
							display="inline"
							disabled={!vendor.length || !selectedItems.length}
							isLoading={isExporting}
							onClick={() => handleExport(selectedItems)}
						>
							{exportText.button}
						</Button>
					}
					placement="top"
				>
					{exportText.tooltip}
				</Tooltip>
			</FilterFlexItem>
		</>
	);
}
